module.exports = __webpack_public_path__ + "assets/2bbcd0f3d9e1411320f572de5b4cf103.png";